<div class="main-container">
  @if (currentUser) {
    <app-shell></app-shell>
  }
  <!-- <app-shell *ngIf="true"></app-shell> -->
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>